// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dueB-7vi,.CUKBem6C{font-size:1rem;margin-bottom:.5em}.dueB-7vi{text-align:center}.OXuOcuTE,._0qKrqL6M{margin-top:1.5rem}.l2A8TWMi{color:#d91413;font-size:.75rem;line-height:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closed": "dueB-7vi",
	"done": "CUKBem6C",
	"hint": "OXuOcuTE",
	"link": "_0qKrqL6M",
	"error": "l2A8TWMi"
};
module.exports = ___CSS_LOADER_EXPORT___;
